import * as __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__ from "@sentry/react";
import * as __WEBPACK_EXTERNAL_MODULE__integrations_mjs_b1fd9b79__ from "../integrations.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_94e53e6f__ from "../redux-enhancer/createSentryReduxEnhancer.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__ from "./utils.mjs";
const isCurrentServiceError = ({ stacktrace, url, publicBuildPath })=>{
    const errorSources = [];
    stacktrace && errorSources.push(stacktrace);
    url && errorSources.push(url);
    return errorSources.some((errorSource)=>errorSource?.includes?.(publicBuildPath));
};
const initBrowserClient = (config)=>{
    if (process.env.SSR) return {};
    const { sentryLoggingEnabled, publicBuildPath, isDebug } = config;
    if (isDebug) console.error('Initing Sentry Browser Client with config', config);
    if (!sentryLoggingEnabled) return {};
    const environment = (0, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.getEnvironment)();
    const isSupportedBrowser = (0, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.isBrowserSupported)();
    const isLoggingEnabled = isSupportedBrowser || environment.isAutotests;
    if (!isLoggingEnabled) return {};
    const { clientConfig, externalConfig } = (0, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.prepareConfig)(config);
    const client = new __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.BrowserClient({
        ...clientConfig,
        transport: __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.makeFetchTransport,
        stackParser: __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.defaultStackParser,
        integrations: (0, __WEBPACK_EXTERNAL_MODULE__integrations_mjs_b1fd9b79__["default"])({
            jsBuildFilterKey: config.jsBuildFilterKey,
            replaysOnErrorSampleRate: clientConfig.replaysOnErrorSampleRate,
            tracesSampleRate: clientConfig.tracesSampleRate
        }),
        debug: config.isDebug
    });
    const scope = new __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.Scope();
    scope.setClient(client);
    client.init();
    window.addEventListener('error', (errorEvent)=>{
        const error = errorEvent?.error;
        if (error && isCurrentServiceError({
            stacktrace: error?.stack,
            publicBuildPath,
            url: errorEvent.filename
        })) {
            scope.captureException(errorEvent);
            error && Object.defineProperty(error, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.ALREADY_HANDLED_FLAG, {
                value: true
            });
        }
    });
    const unhandledRejectionScope = new __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.Scope();
    unhandledRejectionScope.setClient(client);
    window.addEventListener('unhandledrejection', (errorEvent)=>{
        if (isCurrentServiceError({
            stacktrace: String(errorEvent.reason?.stack || ''),
            publicBuildPath
        })) {
            unhandledRejectionScope.setExtra('reason', errorEvent.reason);
            unhandledRejectionScope.setFingerprint([
                String(errorEvent.reason)
            ]);
            const error = new Error(`Unhandled rejection: ${errorEvent.reason}`);
            unhandledRejectionScope.captureException(error);
            if ('object' == typeof errorEvent.reason) Object.defineProperty(errorEvent.reason, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.ALREADY_HANDLED_FLAG, {
                value: true
            });
        }
    });
    return {
        client,
        scope,
        createSentryReduxEnhancer: (options)=>(0, __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_94e53e6f__["default"])((0, __WEBPACK_EXTERNAL_MODULE__redux_enhancer_createSentryReduxEnhancer_mjs_94e53e6f__.prepareSentryReduxEnhancerOptions)(options, {
                redactedFields: config.redactedFields
            }, externalConfig))
    };
};
const browserClient_rslib_entry_ = initBrowserClient;
export { browserClient_rslib_entry_ as default, initBrowserClient };

//# sourceMappingURL=browserClient.mjs.map